import TileView from './TileView';
import CarbonTile from './tile/CarbonTile'

export {
    TileView as default,
    TileView,
    CarbonTile,
};
